import React from 'react'
import type {FlexProps} from '@chakra-ui/react'
import {Text, Flex} from '../../../utils/chakraMonomorphic'

export const ItemText: React.FC<
  {
    text: string
  } & FlexProps
> = ({text, ...rest}) => (
  <Flex {...rest}>
    <Text fontSize='md' lineHeight='base' color='#333' wordBreak='break-word'>
      {text}
    </Text>
  </Flex>
)
